/*
 * Created on 06.04.2016
 *
 * Copyright(c) 1995 - 2016 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */
import { Directive, EventEmitter } from '@angular/core';
import { Column } from './table-column';

/**
 * Diese Directive ist eine interne Directive welche eine zu Componente Table gehört und sich um die sortierung von spallten kümmert.
 *
 * @author imam
 */
@Directive({
    selector: '[sortTable]',
    inputs: ['column'],
    outputs: ['sortChanged'],
    host: {
        '(click)': 'onToggleSort($event)'
    }
})
export class TableSortedDirective {
    public column: Column;
    public sortChanged: EventEmitter<any> = new EventEmitter();

    onToggleSort(event: any) {
        if (event) {
            event.preventDefault();
        }

        if (this.column && this.column.sort && event.currentTarget.localName !== 'input') {
            switch (this.column.sort) {
                case 'asc':
                    this.column.sort = 'desc';
                    break;
                case 'desc':
                    this.column.sort = 'asc';
                    break;
                case 'inactive':
                    this.column.sort = 'asc';
                    break;
                default:
                    break;
            }
            this.sortChanged.emit(this.column);
        }
    }

}
